import { render, staticRenderFns } from "./newprogram.vue?vue&type=template&id=0453ac63&scoped=true"
import script from "./newprogram.vue?vue&type=script&lang=js"
export * from "./newprogram.vue?vue&type=script&lang=js"
import style0 from "./newprogram.vue?vue&type=style&index=0&id=0453ac63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453ac63",
  null
  
)

export default component.exports